<template>
    <div class="container pt-lg-md" style="display: flex;justify-content: center;">
        <div class="row justify-content-center col-lg-5">
            <card type="secondary" shadow header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5" class="border-0"
                style="width: 100%;">
                <div class="text-center text-muted mb-4">
                    <small>Нэвтрэх мэдээллээ оруулна уу</small>
                </div>
                <form role="form">
                    <base-input alternative v-model="formData.email" class="mb-3" placeholder="Имэйл"
                        addon-left-icon="ni ni-email-83">
                    </base-input>
                    <span v-if="errors.email" class="text-danger">{{ errors.email }}</span>

                    <base-input alternative v-model="formData.password" type="password" placeholder="Нууц үг"
                        addon-left-icon="ni ni-lock-circle-open">
                    </base-input>
                    <span v-if="errors.password" class="text-danger">{{ errors.password }}</span>

                    <base-checkbox>
                        Сануулах
                    </base-checkbox>

                    <div class="text-center">
                        <base-button :loading="isLoading" @click="handleLogin" type="primary" class="my-4">
                            Нэвтрэх
                        </base-button>
                    </div>
                </form>
            </card>
            <div class="row mt-3 w-100">
                <div class="col-6">
                    <a href="#" @click.prevent="showForgotPasswordModal">
                        <small class="text-color tex">Нууц үгээ мартсан уу?</small>
                    </a>
                </div>
                <div class="col-6 text-right">
                    <router-link to="/register">
                        <small>Шинэ бүртгэл үүсгэх</small>
                    </router-link>
                </div>
            </div>
        </div>
        <!-- Forgot Password Modal -->
        <modal :show.sync="showModal" title="Нууц үг сэргээх" @ok="handleForgotPassword" @hidden="resetForgotPassword">
            <form @submit.prevent="handleForgotPassword">
                <div class="mb-3">
                    <label for="forgot-email" class="form-label">Имэйл хаягаа оруулна уу</label>
                    <input type="email" id="forgot-email" v-model="forgotPasswordEmail" class="form-control" required>
                    <span v-if="forgotPasswordError" class="text-danger">{{ forgotPasswordError }}</span>
                </div>
            </form>
            <template #footer>
                <base-button variant="secondary" @click="showModal = false">Болих</base-button>
                <base-button variant="primary" @click="handleForgotPassword" :disabled="isSending">
                    {{ isSending ? 'Илгээж байна...' : 'Илгээх' }}
                </base-button>
            </template>
        </modal>
    </div>

    
</template>


<script>
import { mapActions } from 'vuex';
import Modal from "@/components/Modal.vue";
import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;

export default {
    data() {
        return {
            isLoading: false,
            formData: {
                email: '',
                password: ''
            },
            errors: {
                email: '',
                password: ''
            },
            // For forgot password
            showModal: false,
            forgotPasswordEmail: '',
            forgotPasswordError: '',
            isSending: false
        };
    },
    components : {
        Modal
    },
    methods: {
        ...mapActions('auth', ['login']), // Vuex-ийн нэвтрэх функцыг ашиглах үед
        
        validateField(field) {
            this.errors[field] = '';

            switch (field) {
                case 'email':
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!this.formData.email) {
                        this.errors.email = 'Имэйл хаягаа оруулна уу';
                    } else if (!emailRegex.test(this.formData.email)) {
                        this.errors.email = 'Зөв имэйл хаяг оруулна уу';
                    }
                    break;

                case 'password':
                    if (!this.formData.password) {
                        this.errors.password = 'Нууц үгээ оруулна уу';
                    }
                    break;
            }
        },

        validateForm() {
            const fields = ['email', 'password'];
            fields.forEach(field => this.validateField(field));
            return !fields.some(field => this.errors[field]);
        },

        async handleLogin() {
            if (this.isLoading) return;

            if (this.validateForm()) {
                this.isLoading = true;

                try {
                    await this.login({
                        email: this.formData.email.toLowerCase(),
                        password: this.formData.password
                    });

                    // Нэвтрэлт амжилттай болгох үйлдэл
                    this.$emit('close');

                    // Эхлэл хуудас руу шилжүүлэх
                    this.$router.push('/');
                } catch (error) {
                    console.error('Нэвтрэх алдаа:', error);
                    this.$alert.showAlert('Нэвтрэх нэр эсвэл нууц үг буруу байна.', "error");
                } finally {
                    this.isLoading = false;
                }
            }
        },

        // Show Forgot Password Modal
        showForgotPasswordModal() {
            this.showModal = true;
        },

        // Reset modal fields
        resetForgotPassword() {
            this.forgotPasswordEmail = '';
            this.forgotPasswordError = '';
        },

        // Handle forgot password request
        async handleForgotPassword() {
            if (this.isSending) return;

            if (!this.forgotPasswordEmail) {
                this.forgotPasswordError = 'Имэйл хаягаа оруулна уу';
                return;
            }

            this.forgotPasswordError = '';
            this.isSending = true;

            try {
                await axios.post('/forget_password', {
                    email: this.forgotPasswordEmail.toLowerCase()
                });

                this.$alert.showAlert('Нууц үг сэргээх холбоосыг таны имэйл хаяг руу илгээлээ.',"success");
                this.showModal = false;
            } catch (error) {
                console.error('Нууц үг сэргээх алдаа:', error);
                this.$alert.showAlert(`Нууц үг сэргээх алдаа: ${error}`, "success");
                this.forgotPasswordError = 'Алдаа гарлаа. Дахин оролдоно уу.';
            } finally {
                this.isSending = false;
            }
        }
    }
};

</script>

<style>
/* Add any specific styles if necessary */
</style>
